import { FC, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useSearchParams } from "react-router-dom"
import { setAuthHeader } from "@/api/service"
import { clearRefCode } from "@/helpers/refCode"
import { showToast } from "@/helpers/toast"
import { useAppDispatch } from "@/store"
import { setIsAuthorized } from "@/store/slices/player"
import { Loader } from "@/ui/Loader"

export const OAuthCallback: FC = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const accessToken = searchParams.get("accessToken")
    const refreshToken = searchParams.get("refreshToken")

    if (accessToken && refreshToken) {
      setAuthHeader(accessToken, refreshToken)
      clearRefCode()
      dispatch(setIsAuthorized(true))
      navigate("/", { replace: true })
      return
    }

    showToast.error(t("errors.authFailed"))
    navigate("/login", { replace: true })
  }, [searchParams, navigate, dispatch, t])

  return <Loader />
}
